import axios from "axios";
// const API_URL = //'https://agrirent.softuvo.click/api/v1/admin/notifications';
// //"http://localhost:5000/api/v1/admin/notifications";
// "https://app.theshetu.com/api/v1/admin/notifications";
const API_URL = `${process.env.REACT_APP_API_URL}/notifications`;

const apiClient = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

// ✅ Attach token automatically
apiClient.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      config.headers.Authorization = `Bearer ${user.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Get only recent (auto) notifications from backend
export const getAllNotifications = async () => {
  const response = await apiClient.get("/");
  return response.data;
};

// Fetch only unread notifications
export const getUnreadNotifications = async () => {
  const response = await apiClient.get("/unread");
  return response.data;
};

// Mark a single notification as read
export const markNotificationAsRead = async (id) => {
  const response = await apiClient.patch(`/read/${id}`);
  return response.data;
};

// Mark all as read
export const markAllNotificationsAsRead = async () => {
  const response = await apiClient.patch("/read-all");
  return response.data;
};

// Delete a single notification
export const deleteNotification = async (id) => {
  const response = await apiClient.delete(`/${id}`);
  return response.data;
};
